import { SET_ACTIVE_SHOP } from './constants';

const initialState = {
  shop: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SHOP:
      return {
        ...state,
        shop: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;